"use strict";

(function ($) {
  $(function () {
    var $divs = $(".slidingDiv").find(".sectionNone");

    $divs.hide(); /* HIDE CHILDREN INSTEAD */
    let url = ORIS.root_url + "/";
    let urlFull = url + "wp-content/themes/oris/";
    let element = $(".sectionNone");
    let footer = $("footer");
    let header = $("nav");
    let elementHeight = element.height() - header.height();
    let $window = $(window);

    //let viewportHeight = $window.height();
    let viewportHeight = document.documentElement.clientHeight;
    let locationUrl = url + window.location.hash;

    let locationAll = location.origin + location.pathname + window.location.hash;
    let id = window.location.hash;

    // console.log(locationAll);
    // $(location).attr('href')
    // console.log(location);


    // if (locationAll) {
    //   let hash = window.location.hash;
    //   $($(hash)).fadeIn("slow");
    //   alert("hola" + hash)
    // }

    $(".dropdown-item ").removeClass("active");

    //showHref
    //a[href^='#']
    $(".showHref a[href^='#']").click(function (e) {
      e.preventDefault();
      let hash = this.hash;
      console.log("esto es hash 3 "+ hash);

      //remove all pre-existing active classes
      $(".dropdown-item ").removeClass("active");
      //add the active class to the link we clicked
      $(this).addClass("active");

      //id = id.length ? id : $("[name=" + this.hash.slice(1) + "]");

      if (hash) {
        //event.preventDefault();
        $($(hash)).show();

        console.log("esto ess" + hash)

        $('html, body').animate({
          scrollTop: ($(hash).offset().top - ((viewportHeight - elementHeight) / 2))
        }, 500, function () {
          window.location.hash = hash;
        });



      }


      return false;
    });


    // $('.modalLabel').on( 'click',function (e) {
    //   e.preventDefault();
    //   var href = $(this).attr('href');
    //   $(this).attr("data-bs-toggle", "modal");
    //   $(this).attr("data-bs-target", href);

    //   console.log("href" + href);
    //   $(href).modal('show')
    // });

    $(".modalLabel a[href^='#']").click(function (e) {
      e.preventDefault();
      //let href = $(this).attr('href');
      let href = this.hash;
      $(this).attr("data-bs-toggle", "modal");
      $(this).attr("data-bs-target", href);
      //let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(href)) // Returns a Bootstrap modal instance
      console.log("href " + href);
      //const modal = new bootstrap.Modal(modalElement, {backdrop: false, keyboard: true, focus: true});

      let modal = new bootstrap.Modal(href);

 


  
     // Show or hide:
     modal.show();
     modal.hide();
    
    });

    var navpos = $('#navbar').offset();
    console.log(navpos.top);
      $(window).bind('scroll', function() {
        if ($(window).scrollTop() > navpos.top) {
         $('#navbar').addClass('fixed-top');
         }
         else {
           $('#navbar').removeClass('fixed-top');
         }
      });


      console.log("esto es ruta "+ urlFull);
      console.log("esto es hash 1 "+ locationUrl);
      console.log("esto es hash 2 "+ locationAll);



      $('#bs4navbar').prepend('<img src="'+urlFull+'images/logo.svg" height="64px" width="64px" class="img-logo">');

  });
})(jQuery);


